import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FaCogs, FaShieldAlt, FaCarAlt, FaWrench, FaBus, FaBoxes, FaTrash, FaFileAlt, FaTruck } from 'react-icons/fa';
import { FaTruckDroplet, FaTruckFast, FaTruckPlane } from "react-icons/fa6";
import { BsPeople, BsPerson } from 'react-icons/bs';
import Sidebar from '../composant_reutilisable/sidebar';
import Navbar from '../composant_reutilisable/navbar';
import useAuth from '../composant_reutilisable/useAuth';
import Footer from '../composant_reutilisable/footer';
import { useNavigate } from 'react-router-dom';
import { ClipboardList } from 'lucide-react';
import Pas_acces from '../composant_reutilisable/pas_acces';
import axios from 'axios';

const Admin = () => {
    useAuth();
    const user_id = localStorage.getItem('userId');
    const navigate = useNavigate();
    const accesGroupe = JSON.parse(localStorage.getItem('accesGroupe')) || [];

    useEffect(() => {
        if (user_id) {
            document.title = "Transportpro | Administration";
        }
    }, [user_id]);

    // Définition des éléments de menu avec leurs permissions requises
    const menuItems = [
        { icon: <BsPeople />, text: 'Groupes', link: '/Liste-groupe', accessKey: 'Groupes' },
        { icon: <BsPerson />, text: 'Utilisateurs', link: '/Liste-utilisateur', accessKey: 'Utilisateurs' },
        // { icon: <FaTruck />, text: 'Enrôlement', link: '/Enrolement-admin', accessKey: 'EnrolementAdmin' },
        { icon: <FaFileAlt />, text: 'Suivi documents', link: '/Pieces-admin', accessKey: 'ListePiecesAdmin' },
        { icon: <FaCarAlt />, text: 'Elémentaires', link: '/Elementaires', accessKey: 'Elementaires' },
        { icon: <FaWrench />, text: 'Paramètres', link: '/Liste-parametre', accessKey: 'Parametres' },
        // { icon: <FaBoxes />, text: 'Fret', link: '/Liste-declaration-fret', accessKey: 'Fret' },
        { icon: <ClipboardList />, text: 'Journalisation', link: '/Liste-journalisation', accessKey: 'Journalisation' },
        // { icon: <FaTrash />, text: 'Corbeilles', link: '/Corbeilles', accessKey: 'Corbeille' },
    ];

    const handleClick = (lien) => {
        navigate(lien);
    };

    const userHasAccess = (accessKey) => {
        return accesGroupe.includes(accessKey);
    };

    const [accesGroupes, setAccesGroupes] = useState([]);
    const [groupeId, setGroupeId] = useState(null);
    const groupe = localStorage.getItem('groupe_id');

    const verifGroupe = async () => {
        const groupeStored = localStorage.getItem('groupe_id');
        const accesGroupeStored = localStorage.getItem('accesGroupe');

        if (groupeStored && accesGroupeStored) {
            setGroupeId(groupeStored);
            setAccesGroupes(JSON.parse(accesGroupeStored));
        } else {
            try {
                const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}`);
                if (response.status === 200) {
                    const data = response.data;
                    setGroupeId(data.groupe);

                    let cleanedAccessArray = [];
                    if (Array.isArray(data.acces)) {
                        cleanedAccessArray = data.acces.map((item) =>
                            item.acces
                                ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
                                : []
                        ).flat();

                        setAccesGroupes(cleanedAccessArray);
                    }

                    localStorage.setItem('groupe', data.groupe);
                    localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
                }
            } catch (error) {
                // console.error('Erreur lors de la vérification du groupe', error);
            }
        }
    };

    useEffect(() => {
        if (user_id) {
            verifGroupe();
        }
    }, [user_id]);

    if (!accesGroupes.includes("Administration")) {
        return (
            <Pas_acces />
        );
    }

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <h2 className='d-flex align-items-center'><FaCogs size={25} className='mr-2' /> Administration</h2>
                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Menu`}> Accueil</Link>
                                    </li>
                                    <li className="breadcrumb-item">
                                        Administration
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>

                    <div className="wrapper wrapper-content animated fadeInRight text-center p-5">
                        <div className="row mx-auto justify-content-center">
                            {menuItems.map((item, index) => (
                                userHasAccess(item.accessKey) && (
                                    <div key={index} className="col-md-2 mb-4">
                                        <div
                                            className="card rounded shadow-sm h-100 d-flex flex-column justify-content-center align-items-center"
                                            onClick={() => handleClick(item.link)}
                                            style={{
                                                cursor: 'pointer',
                                                transition: 'transform 0.2s'
                                            }}
                                            onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                                            onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                                        >
                                            <div className="card-body">
                                                <div className="mb-3 icon-small">{item.icon}</div>
                                                <h5 ><Link className='text-dark' to={item.link}>{item.text}</Link></h5>
                                            </div>
                                        </div>
                                    </div>
                                )
                            ))}
                        </div>
                    </div>

                    <div className="footer text-center">
                        {/* <div className="float-right">
                        10GB of <strong>250GB</strong> Free.
                    </div> */}
                        <Footer />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Admin;